import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Chip,
  LinearProgress,
  Divider
} from '@mui/material';
import {
  Delete,
  CheckCircle,
  Error,
  InsertDriveFile,
  FileCopy
} from '@mui/icons-material';
import { formatFileSize, getStatusIcon } from './utils/fileUtils';
import './UploadProgressList.css';

const UploadProgressList = ({ files, uploadProgress, uploading, onRemoveFile }) => {
  if (files.length === 0) return null;

  const getStatusIconComponent = (status, progress) => {
    const iconProps = getStatusIcon(status, progress);
    
    switch (status) {
      case 'completed':
        return <CheckCircle sx={iconProps} />;
      case 'uploading':
        return <LinearProgress variant="determinate" value={progress} sx={iconProps} />;
      case 'error':
        return <Error sx={iconProps} />;
      default:
        return <InsertDriveFile sx={iconProps} />;
    }
  };

  return (
    <Paper className="upload-progress-container">
      <Box className="upload-progress-header">
        <Typography variant="h6" className="upload-progress-title">
          Uploading Documents
        </Typography>
        <Chip 
          label={`${files.filter(f => f.status === 'completed').length}/${files.length} completed`}
          className="upload-progress-chip"
        />
      </Box>
      
      <List className="upload-progress-list">
        {files.map((file, index) => (
          <React.Fragment key={file.id}>
            <ListItem className="upload-progress-item">
              <ListItemIcon className="file-status-icon">
                {getStatusIconComponent(file.status, file.progress)}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography className="file-name">
                    {file.name}
                  </Typography>
                }
                secondary={
                  <Typography className="file-details">
                    <FileCopy className="file-copy-icon" />
                    {formatFileSize(file.size)} • {
                      file.status === 'completed' ? 'Uploaded' : 
                      file.status === 'uploading' ? 'Uploading...' : 'Pending'
                    }
                  </Typography>
                }
              />
              {file.status === 'completed' && (
                <IconButton 
                  onClick={() => onRemoveFile(file.id)}
                  className="remove-file-btn"
                >
                  <Delete />
                </IconButton>
              )}
            </ListItem>
            {index < files.length - 1 && (
              <Divider className="file-divider" />
            )}
          </React.Fragment>
        ))}
      </List>
      
      {uploading && (
        <Box className="upload-progress-footer">
          <Typography className="upload-progress-text">
            Uploading files... {Math.round(uploadProgress)}%
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={uploadProgress}
            className="upload-progress-bar"
          />
        </Box>
      )}
    </Paper>
  );
};

export default UploadProgressList;
